"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _constants = require("../../constants");
var _customPropTypes = _interopRequireDefault(require("../../util/custom-prop-types"));
var _Avatar = require("./Avatar.styles");
/**
 * @since 6.10.0
 */
var Avatar = function Avatar(props) {
  var additionalProps = {};
  if (props.fullName) {
    additionalProps['aria-label'] = props.fullName;
  }
  return /*#__PURE__*/_react.default.createElement(_Avatar.StyledAvatar, (0, _extends2.default)({}, additionalProps, props));
};
exports.Avatar = Avatar;
Avatar.displayName = 'Avatar';
Avatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Considering setting this prop to `true` if the avatar is used for presentational
   * content only. In other words, if the avatar sits next to a heading with similar
   * content, then there is no need for screen readers to read both he avatar label and
   * the heading content.
   */
  'aria-hidden': _propTypes.default.string,
  /**
   * Provide an accessible label for the avatar.
   * Use this only if you aren't already providing alt text in your Image,
   * or if you want to provide a different value than `fullName`.
   */
  'aria-label': _propTypes.default.string,
  /**
   * Use `children` to provide an `Icon`,
   * `Image`, or custom text content.
   * For simple letter avatars, use the `fullName` prop instead.
   */
  'children': _propTypes.default.node,
  /**
   * @deprecated Use inline media query objects
   */
  'mediaQuery': _customPropTypes.default.mediaQuery,
  /**
   * The `fullName` prop is used for generating simple letter avatars and
   * providing  the `aria-label` attribute. For custom letters, pass the text as `children`.
   */
  'fullName': _propTypes.default.string,
  /**
   * The avatar size.
   *
   * Supports inline media query objects.
   */
  'size': _customPropTypes.default.inlineMediaQuery(_propTypes.default.oneOf(Object.values(_constants.AVATAR_SIZES))),
  /**
   * Customize the color of the avatar.
   * When using a colored background, the text will change to white. The default background color
   * is gray.
   */
  'background': _propTypes.default.oneOf(['aqua600', 'green500', 'blue500', 'purple500', 'gray200'])
} : {};
Avatar.defaultProps = {
  fullName: '',
  size: _constants.AVATAR_SIZES.lg,
  background: 'gray200'
};